'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactI18next = require('react-i18next');

var _propTypes3 = require('utils/prop-types');

var _datetime = require('helpers/datetime');

var _progresspopup = require('redux/modules/progresspopup');

var actions = _interopRequireWildcard(_progresspopup);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProgressPopup.scss');

var timerTimeout = null;

var ProgressPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    text: state.progresspopup.text,
    timeout: state.progresspopup.timeout,
    title: state.progresspopup.title,
    visible: state.progresspopup.visible
  };
}, (0, _extends3.default)({}, actions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProgressPopup, _Component);

  function ProgressPopup() {
    var _ref;

    (0, _classCallCheck3.default)(this, ProgressPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressPopup.__proto__ || (0, _getPrototypeOf2.default)(ProgressPopup)).call.apply(_ref, [this].concat(args)));

    _this.state = { width: '100%', timer: '00:00' };
    return _this;
  }

  (0, _createClass3.default)(ProgressPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.visible) {
        clearTimeout(timerTimeout);
        this.update({ timeout: nextProps.timeout });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
      clearTimeout(timerTimeout);
    }
  }, {
    key: 'update',
    value: function update() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$timeout = _ref2.timeout,
          timeout = _ref2$timeout === undefined ? this.props.timeout : _ref2$timeout;

      this.setState({ width: '100%', timeout: timeout });
      setTimeout(function () {
        if (!_this2.unmounted) {
          _this2.setState({ width: 0, timeout: timeout });
          _this2.updateTimer();
        }
      }, 100);
    }
  }, {
    key: 'updateTimer',
    value: function updateTimer() {
      var _this3 = this;

      if (!this.unmounted) {
        var timeout = this.state.timeout;

        this.setState({ timer: (0, _datetime.secToMin)(timeout), timeout: timeout - 1, isTimeEnd: timeout <= 0 });
        if (timeout) {
          timerTimeout = setTimeout(function () {
            return _this3.updateTimer();
          }, 1000);
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.props.hide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          t = _props.t,
          text = _props.text,
          timeout = _props.timeout,
          title = _props.title,
          visible = _props.visible;
      var _state = this.state,
          width = _state.width,
          timer = _state.timer,
          isTimeEnd = _state.isTimeEnd;


      if (!visible) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.popup, className) },
        _react2.default.createElement(
          'div',
          { className: styles.container },
          _react2.default.createElement(
            'div',
            { className: styles.textContainer },
            _react2.default.createElement('span', { className: styles.infoIcon }),
            _react2.default.createElement(
              'span',
              { className: styles.message },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                title || t('Information')
              ),
              _react2.default.createElement(
                'div',
                { className: styles.text },
                text || t('Please wait while we prepare your download files')
              )
            ),
            _react2.default.createElement(
              'span',
              { className: styles.closeButton, onClick: this.hide },
              '\u2715'
            )
          ),
          !isTimeEnd && _react2.default.createElement(
            'span',
            { className: styles.timer },
            timer
          ),
          _react2.default.createElement('div', { className: styles.progressBar, style: { transitionDuration: timeout + 's', width: width } })
        )
      );
    }
  }]);
  return ProgressPopup;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  hide: _propTypes2.default.func,
  t: _propTypes2.default.func,
  text: _propTypes3.node,
  timeout: _propTypes2.default.number,
  title: _propTypes3.node,
  visible: _propTypes2.default.bool
}, _class3.defaultProps = {
  timeout: 10
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ProgressPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressPopup/ProgressPopup.js
// module id = 2044
// module chunks = 1